
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

window.scrollAnimation = new (function () {
  this.scroller = false;
  this.init = function () {
    gsap.registerPlugin(ScrollTrigger)
    window.globalScroll.smooth.on('scroll', ScrollTrigger.update)
    gsap.ticker.add((time) => {
      window.globalScroll.smooth.raf(time * 1000)
    })

    gsap.ticker.lagSmoothing(0)
  }
  this.initGlobal = function () {

  }


  this.trigger = []
  this.resetTrigger = function () {

    this.trigger.forEach(t => t.kill(true));
    let header = document.querySelector('header');
    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);

  }
  this.initView = function () {
    let dataTimeline = gsap.timeline({
      paused: false,
    })
    dataTimeline.to('[data-barba-namespace]:last-of-type .before-data__wrapper', {
      xPercent: 100,
      repeat: 3,
      duration: 10,
      ease: 'none',
      repeatDelay: 0,

    }, 'animation')
    dataTimeline.fromTo('[data-barba-namespace]:last-of-type .after-data__wrapper', {
      xPercent: -100,
      repeat: 3,
      duration: 10,
      ease: 'none',
      repeatDelay: 0,

    }, {
      xPercent: 0,
      repeat: 3,
      duration: 10,
      ease: 'none',
      repeatDelay: 0,
    }, 'animation')


    dataTimeline.to('[data-barba-namespace]:last-of-type .circle__dash', {
      rotate: 360,
      repeat: 3,
      duration: 10,
      ease: 'none',
      repeatDelay: 0,

    }, 'animation')

    dataTimeline.to($("[data-barba-namespace]:last-of-type .before-data__wrapper:nth-child(1) .before-data__item:not(.cloned)"), {
      scale: .1,
      yPercent: 100,
      repeat: 3,
      ease: 'power1.inOut',
      duration: 2,
      stagger: {
        each: 2,
        onComplete: function () {
          gsap.set(this.targets()[0], { scale: 1, yPercent: 0 })
        }

      },

    }, 'animation');
    dataTimeline.to($("[data-barba-namespace]:last-of-type .before-data__wrapper:nth-child(2) .before-data__item:not(.cloned)"), {
      scale: .1,
      repeat: 3,
      ease: 'power1.inOut',
      duration: 2,
      stagger: {
        each: 2,
        onComplete: function () {
          gsap.set(this.targets()[0], { scale: 1, yPercent: 0 })
        }

      },

    }, 'animation');
    dataTimeline.to($("[data-barba-namespace]:last-of-type .before-data__wrapper:nth-child(3) .before-data__item:not(.cloned)"), {
      scale: .1,
      yPercent: -100,
      repeat: 3,
      ease: 'power1.inOut',
      duration: 2,
      stagger: {
        each: 2,
        onComplete: function () {
          gsap.set(this.targets()[0], { scale: 1, yPercent: 0 })
        }

      },

    }, 'animation');

    dataTimeline.fromTo($("[data-barba-namespace]:last-of-type .after-data__wrapper:nth-child(1) .after-data__item:not(.cloned)"), {
      scale: .1,
      yPercent: 100,
      repeat: 3,
      ease: 'power1.inOut',
      duration: 2,
      stagger: {
        each: -2,
        onComplete: function () {
          console.log('complet');
          gsap.set(this.targets()[0], { scale: 1, yPercent: 0 })
        }

      },

    }, {

      scale: 1,
      yPercent: 0,
      repeat: 3,
      ease: 'power1.inOut',
      duration: 2,
      stagger: {
        each: -2,
        onComplete: function () {
          console.log('complet');
          gsap.set(this.targets()[0], { scale: 1, yPercent: 0 })
        }

      },


    }, 'animation');
    dataTimeline.fromTo($("[data-barba-namespace]:last-of-type .after-data__wrapper:nth-child(2) .after-data__item:not(.cloned)"), {
      scale: .1,
      repeat: 3,
      ease: 'power1.inOut',
      duration: 2,
      stagger: {
        each: -2,
        onComplete: function () {
          gsap.set(this.targets()[0], { scale: 1, yPercent: 0 })
        }

      },

    }, {
      scale: 1,
      repeat: 3,
      ease: 'power1.inOut',
      duration: 2,
      stagger: {
        each: -2,
        onComplete: function () {
          gsap.set(this.targets()[0], { scale: 1, yPercent: 0 })
        }

      },

    }, 'animation');
    dataTimeline.fromTo($("[data-barba-namespace]:last-of-type .after-data__wrapper:nth-child(3) .after-data__item:not(.cloned)"), {
      scale: .1,
      yPercent: -100,
      repeat: 3,
      ease: 'power1.inOut',
      duration: 2,
      stagger: {
        each: -2,
        onComplete: function () {
          gsap.set(this.targets()[0], { scale: 1, yPercent: 0 })
        }

      },

    }, {
      scale: 1,
      yPercent: 0,
      repeat: 3,
      ease: 'power1.inOut',
      duration: 2,
      stagger: {
        each: -2,
        onComplete: function () {
          gsap.set(this.targets()[0], { scale: 1, yPercent: 0 })
        }

      },
    }, 'animation');

    ScrollTrigger.create({
      animation: dataTimeline,               // Associe la timeline à ScrollTrigger
      trigger: ".data-section",  // Élément qui déclenche l'animation
      start: "top bottom",            // Quand commencer l'animation
      end: "bottom top",           // Quand terminer l'animation
      scrub: 4,
    });
    dataTimeline.timeScale(1.5)


    this.resetTrigger();


    let mm = gsap.matchMedia();





  }

  this.addAnimation = function () {
    this.resetTrigger();

  }
  this.initEnterAnimation = function () {

  }


  this.lazyload = function () {
    gsap.utils.toArray("[data-barba-namespace]:last-of-type .container").forEach((section, i) => {
      ScrollTrigger.create({
        trigger: section,
        start: "-50% bottom",
        once: true,
        onEnter: () => {
          window.imageLoader.lazy(section);
        },
        onEnterBack: () => {
          window.imageLoader.lazy(section);
        }
      });
    });
  }
  this.update = function () {
    ScrollTrigger.refresh(false)
  }
});
